import { render, staticRenderFns } from "./invoicesgrid.vue?vue&type=template&id=1b1fbcf6"
import script from "./invoicesgrid.vue?vue&type=script&lang=js"
export * from "./invoicesgrid.vue?vue&type=script&lang=js"
import style0 from "./invoicesgrid.vue?vue&type=style&index=0&id=1b1fbcf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports